import { ReactNode } from 'react';
import { Platform, StyleProp, StyleSheet, View, type ViewProps, ViewStyle } from 'react-native';

import { Text, tokens } from '@fhs/ui';

interface Props {
  children: ReactNode;
  circularSize?: number;
  circular?: boolean;
  color?: string;
  textColor?: string;
  style?: StyleProp<ViewStyle>;
  icon?: ReactNode;
  /** Use `none` on web when the badge sits inside a larger pressable so VO hover targets the parent. */
  pointerEvents?: ViewProps['pointerEvents'];
}

export function Badge({
  children,
  circular = false,
  circularSize = 24,
  color = tokens.colors.$success,
  textColor = tokens.colors.$white,
  style,
  icon,
  pointerEvents,
}: Props) {
  const borderRadius = circular ? 30 : 4;
  const formatStyle = circular
    ? { borderRadius, height: circularSize, width: circularSize }
    : { borderRadius, paddingHorizontal: 8, paddingVertical: 3.5 };
  const textPointerPassthrough =
    pointerEvents === 'none' && Platform.OS === 'web'
      ? ({ pointerEvents: 'none' } as const)
      : {};
  return (
    <View
      pointerEvents={pointerEvents}
      style={[styles.badge, { backgroundColor: color }, formatStyle, style]}
    >
      {icon && icon}
      <Text.Ui weight="semibold" size="sm" style={{ color: textColor }} {...textPointerPassthrough}>
        {children}
      </Text.Ui>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 4,
  },
});
